import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { PEV } from "../../../../../common/utils";
import * as service from "./service";

export const generateReviewedAccessTableId = (userId, appId) =>
  `reviewedAccessTable-${userId}-${appId}`;

const initialState = {
  reviewedAccesses: {},
};

const getReviewedAccess = createAsyncThunk("reviewedAccesses/fetch", async (param) => {
  return await service.fetchReviewedAccesses(param.userId);
});

const ReviewedAccessSlice = createSlice({
  name: "reviewedAccesses",
  initialState,
  reducers: {},
  extraReducers: {
    [getReviewedAccess.pending.type]: (state, action) => {
      let userId = action.meta.arg.userId;
      state.reviewedAccesses[userId] = PEV(
        { ...state.reviewedAccesses.value },
        "Fetching reviewedAccesses"
      );
    },
    [getReviewedAccess.fulfilled.type]: (state, action) => {
      let userId = action.meta.arg.userId;
      state.reviewedAccesses[userId] = PEV(action.payload);
    },
    [getReviewedAccess.rejected.type]: (state, action) => {
      let userId = action.meta.arg.userId;
      state.reviewedAccesses[userId] = PEV(
        { ...state.reviewedAccesses.value },
        null,
        "Error while fetching reviewedAccesses"
      );
    },
  },
});

export const ReviewedAccessReducer = ReviewedAccessSlice.reducer;
export const ReviewedAccessActions = { getReviewedAccess: getReviewedAccess };
